import { LEAVE_ROLE } from '@/utils/constUtils'
import API from '@/api'
import { getItem, getSearchValueByKey } from '@/utils/comUtils'
export default {
  methods: {
    checkRole() {
      let _roleList = this.getRoleList()

      if (_roleList.indexOf(this.currentRole) === -1) {
        // 失效 初始化角色
        this.$store.dispatch('initCurrentRole')

        // 家长
        if (this.currentRole === LEAVE_ROLE.guardian) {
          this.manageGuardian()
          return
        }
        // 老师
        this.manageTeacher()
      }
    },
    // 微应用专用 当前操作者角色列表
    getRoleList() {
      let _list = []
      let { isCombineTeacher, isGuardian } = this.$store.getters

      // 老师
      isCombineTeacher && _list.push(LEAVE_ROLE.classTeacher)
      // 家长
      isGuardian && _list.push(LEAVE_ROLE.guardian)

      return _list
    },
    getMatchedCampus(_role = LEAVE_ROLE.classTeacher) {
      let campus = []
      if (LEAVE_ROLE.classTeacher === _role) {
        campus = this.$store.getters.teacherCampusList
      }
      return campus
    },
    // 学生权限管理
    manageStudent() {
      API.getAllowStudentSubmitLeave({
        roleType: LEAVE_ROLE.student
      })
        .then(canAccess => {
          if (!canAccess || canAccess.result) {
            this.noAccess = true
            return
          }
          this.changeRole(LEAVE_ROLE.student)
          this.manageRolePageSetup(LEAVE_ROLE.student)
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 老师权限管理
    manageTeacher() {
      let campusList = this.getMatchedCampus(this.currentRole) || []
      let campusLen = campusList.length

      if (!campusLen) {
        this.routerAsyncError(0)
        return
      }

      // 校区列表为一时，直接默认为当前校区
      if (campusLen === 1) {
        this.$store.commit('changeCurrentCapmus', campusList[0] || {})
        this.manageRolePageSetup()
        return
      }

      // 判断当前缓存的校区是否正确，假如有的话；获取当前校区会自动触发。
      let curCapmus = this.$store.getters.currentCapmus || {}

      let filterCapmusList = campusList.filter(
        item => item.tpId === curCapmus.tpId
      )

      if (filterCapmusList.length) {
        this.$store.commit('changeCurrentCapmus', filterCapmusList[0] || {})
        this.manageRolePageSetup()
      } else {
        // 失效 进入选择角色页面
        this.chooseRole()
      }
    },
    // 家长权限管理
    manageGuardian() {
      let { studentList, studentNumber } = this.$store.getters
      if (!(studentList && studentList.length)) {
        this.chooseRole()
        // this.noAccess = true
        return
      }
      if (
        !studentNumber ||
        !studentList.filter(v => v.memberId === studentNumber).length
      ) {
        this.$store.commit('studentNumber', studentList[0].memberId)
      }

      this.manageRolePageSetup(LEAVE_ROLE.guardian)
    },
    // 切换角色
    changeRole(role) {
      role && this.$store.commit('changeCurrentRole', role)
    },
    // 选择角色
    chooseRole() {
      // 进入前判断是否有权限
      if (this.isCanChangeRole && this.isCanAccess) {
        this.$router.replace({ path: '/role' })
      } else {
        // this.noAccess = true
        this.$store.commit('changeCurrentRole', null)
        this.$router.replace({ name: 'PageEntryInformationIndex' })
      }
    },
    // 统一处理所有角色的启动页
    async manageRolePageSetup(role) {
      // 学生
      // 老师、家长的一致（家长的有重定向）

      // 默认老师角色
      role = role || LEAVE_ROLE.classTeacher
      let PATH_MAP = {
        [LEAVE_ROLE.student]: '/leave/index',
        [LEAVE_ROLE.guardian]: '/guardian',
        [LEAVE_ROLE.classTeacher]: '/home'
      }
      const platformSource = getItem('platformSource')
      const _query = { ...(this.$route.query || {}) }
      await this.$store.dispatch('getRoleIdList')
      if (
        ['8'].includes(platformSource) &&
        ![LEAVE_ROLE.guardian, LEAVE_ROLE.student].includes(role)
      ) {
        this.$router.replace({
          path: '/classcard/familycall/list',
          query: _query
        })
        return
      }
      if (
        ['12'].includes(platformSource) &&
        ![LEAVE_ROLE.guardian, LEAVE_ROLE.student].includes(role)
      ) {
        this.$router.replace({
          path: '/meal/index',
          query: { ..._query, needReload: true }
        })
        return
      }
      const redirectToFace = getSearchValueByKey('redirectToFace')
      // 如果链接上有需要重定向录脸页标记redirectToFace=true，则跳转录脸入口页面
      if (redirectToFace) {
        PATH_MAP = {
          [LEAVE_ROLE.student]: '/leave/index',
          [LEAVE_ROLE.guardian]: '/entryInformation/guardian/index',
          [LEAVE_ROLE.classTeacher]: '/entryInformation/index'
        }
      }
      this.$router.replace({
        path: PATH_MAP[role]
      })
    }
  }
}
